import React from 'react';
import './rtCommon.css';

/**
 * Content-section page title (+ optional subtitle / actions).
 * Screen name and buttons live here — not in the sticky Hi header.
 */
const RTContentHeader = ({ title, subtitle, actions, className = '' }) => {
  if (!title && !subtitle && !actions) return null;
  return (
    <div className={`rt-content-header ${className}`.trim()}>
      <div className="rt-content-header-text">
        {title ? <h2 className="rt-content-title">{title}</h2> : null}
        {subtitle ? <p className="rt-content-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? (
        <div className="rt-content-header-actions">{actions}</div>
      ) : null}
    </div>
  );
};

export default RTContentHeader;
